

exports.capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

exports.toEuro = (value, nbDigits) => {
    try {
        if (nbDigits == undefined) nbDigits = 0;

        if (typeof value != 'number') return "";
            
        const stringValue = value.toString();
        const splitAtDigit = stringValue.split('.');

        let arrayValue = splitAtDigit[0].split('');
        arrayValue.reverse();
        
        let count = 0;
        let result = [];

        arrayValue.forEach(number => {
            count ++;
            if (count == 4 && number != '-') {
                result.push('.');
                count = 1;
            }
                
            result.push(number);
        });
        result.reverse();
        result = result.join('');

        if (nbDigits > 0)
            result = result + ',';

        for (let i = 0; i < nbDigits; i++) {
            if (splitAtDigit[1] == undefined || splitAtDigit[1][i] == undefined )
                result = result + "0";
            else
                result = result + splitAtDigit[1][i];
        }

        return result + '€';
        
    } catch (err) {
        return value;
    }
}

exports.toPercent = (number) => {
    const percent = number * 100;
    return `${ percent.toFixed(2) }%`;
}

exports.dateToString = (date, isEnVersion) => {
    if (!date) return undefined

    const d = new Date(date)
    
    const year = d.getFullYear(d)
    let month = d.getMonth() + 1
    let day = d.getDate()

    if (month < 10) {
        month = '0' + month
    }

    if (day < 10) {
        day = '0' + day
    }

    if (isEnVersion) {
        return year + '-' + month + '-' + day
    } else {
        return day + '/' + month + '/' + year
    }
}